module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('p', [_vm._v("I'm best reached over e-mail.  Academic/official business e-mail should go to paul.gowder [at-symbol] law.northwestern.edu.  I prefer to keep personal and especially political business separate from work accounts, so, for all non-academic/non-official business, please use paul.gowder [at-symbol] gmail.com.")]), _vm._v(" "), _c('p', [_vm._v("I really prefer not to receive unsolicited telephone calls, and I very rarely check voicemail unless a call has been prearranged.")]), _vm._v(" "), _c('p', [_vm._v("Other web presences that you might use to reach me, find out more about me, etc.:")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.law.northwestern.edu/faculty/profiles/PaulAGowder/"
    }
  }, [_vm._v("Official law school profile")])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "http://www.linkedin.com/in/paulgowder"
    }
  }, [_vm._v("Linkedin")])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "https://philpeople.org/profiles/paul-gowder"
    }
  }, [_vm._v("PhilPapers/PhilPeople")])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "http://orcid.org/0000-0001-7641-585X"
    }
  }, [_vm._v("Orcid")])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "https://papers.ssrn.com/sol3/cf_dev/AbsByAuth.cfm?per_id=1158647"
    }
  }, [_vm._v("SSRN")])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.zotero.org/paulgowder"
    }
  }, [_vm._v("Zotero")])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "https://github.com/paultopia"
    }
  }, [_vm._v("Github")])])]), _vm._v(" "), _c('li', [_c('p', [_c('a', {
    attrs: {
      "href": "https://www.amazon.com/author/paulgowder"
    }
  }, [_vm._v("Amazon Author Page")])])])]), _vm._v(" "), _c('p', [_vm._v("I'm available to provide comments to the press on constitutional law, ethics in public life, democracy and the rule of law, platform governance, and legal technology. I'm available for consulting on difficult legal matters for lawyers only (I don't offer legal services to the public), and on ethics and public policy related issues in my research specialties for companies, governments, etc. I'm also available for interesting and exciting tech projects. Now that "), _c('a', {
    attrs: {
      "href": "https://networked-leviathan.com"
    }
  }, [_vm._v("The Networked Leviathan")]), _vm._v(" is published, I am once again available to assist technology companies in governance design as well.")]), _vm._v(" "), _c('p', [_vm._v("If I'm speaking at your event or you otherwise need them, you can download a "), _c('a', {
    attrs: {
      "href": "/gowder-headshot-fullsize.jpg"
    }
  }, [_vm._v("full-resolution headshot")]), _vm._v(" and a "), _c('a', {
    attrs: {
      "href": "/gowder-speaker-bio.txt"
    }
  }, [_vm._v("speaker bio")]), _vm._v(".")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ce18217","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-markdown-loader/_cache/contact-5.vue
// module id = 195
// module chunks = 0